import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
import Searcher from './Searcher';
import { getArcGisParser } from '../util/getArcGisParser';
/**
 *
 * @class arcGisSearcher Searches an arcGIS service. Bla.
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.ArcGisSearcher
 * @param {Object} options arcGisSearcher expects these properties:<br/>
 * @param {string} options.host "Service endpoint (SpatialSuite Url) eg.: [http:]//sps-demo.septima.dk[:80]. Protocol and port are optional"
 * @param {string} options.datasources Comma separated list of indexed data sources to search. Default: "*"
 *
 * @example
 * var arcGisSearcherOptions = {
 *     catalogUrl : http:// <catalog-url>" eg: "http://kortservice.vejle.dk/gis/rest/services",
 *     serviceName: "[folder/]service" eg: "GISWEB2/FamilieSocial",
 *     onSelect : function(result) {
 *          log('<b>'+ ArcGIS objekt + ':</b> '+ result.title + '<br/>');
 *     },
 *     layers : "*" or ["layer1Name", "layer2Name"],
 *     matchesPhrase: "Begynder med ",
 *     searchDelay: 200
 * };
 * searchers.push({title : '', searcher : new Septima.Search.arcGisSearcher(arcGisSearcherOptions)});
 *
 */

export default Class(Searcher,
/**  @lends Septima.Search.arcGisSearcher# */
{
  catalogUrl: null,
  serviceName: null,
  serviceLayers: [],
  serviceLayerIds: [],
  layersToSearch: "*",

  /**
  * This function is called when a result is selected.
  * @callback Septima.Search.arcGisSearcher~selectCallback
  * @param {Object} result
  * @param result.title {string}
  * @param result.description {string}
  * @param result.data {object} arcGIS feature
  * @param result.data.heading {string} title
  */
  initialize: function initialize(options) {
    options.usesGeoFunctions = true;
    if (options === undefined) throw "New Septima.Search.arcGisSearcher(options): Options missing.";
    if (!options.source) options.source = "ArcGis";
    this.source = options.source;
    this.Searcher(options);
    this.catalogUrl = options.catalogUrl;
    this.serviceName = options.serviceName;
    this.serviceLayers = [];
    if (options.layers === undefined || this.layersToSearch === "" || this.layersToSearch === " ") this.layersToSearch = "*";else this.layersToSearch = options.layers;
    this.serviceURL = this.catalogUrl + '/' + this.serviceName + '/MapServer';
    this.layersReady = this.getLayers();
    this.arcGisParser = getArcGisParser();
  },
  getLayers: function () {
    var _getLayers = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var data, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, layer;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch2(this.serviceURL + '/layers?f=json', {});

            case 2:
              data = _context.sent;

              if (!(typeof data.layers !== 'undefined')) {
                _context.next = 23;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 7;

              for (_iterator = data.layers[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                layer = _step.value;

                if (layer.type === 'Feature Layer' && this.inLayersToSearch(layer)) {
                  this.serviceLayers.push(layer);
                  this.serviceLayerIds.push(layer.id);
                  this.registerType(this.source, layer.name);
                }
              }

              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](7);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 15:
              _context.prev = 15;
              _context.prev = 16;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 18:
              _context.prev = 18;

              if (!_didIteratorError) {
                _context.next = 21;
                break;
              }

              throw _iteratorError;

            case 21:
              return _context.finish(18);

            case 22:
              return _context.finish(15);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[7, 11, 15, 23], [16,, 18, 22]]);
    }));

    function getLayers() {
      return _getLayers.apply(this, arguments);
    }

    return getLayers;
  }(),
  ready: function ready() {
    return this.layersReady;
  },
  inLayersToSearch: function inLayersToSearch(layer) {
    if (this.layersToSearch === "*") {
      return true;
    } else {
      var arrLayersToSearch = this.layersToSearch.split(",");
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = arrLayersToSearch[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var arrLayer = _step2.value;
          if (arrLayer.toLowerCase().trim() === layer.name.toLowerCase()) return true;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    return false;
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(query, caller) {
      var layerIds, searchText, layer, data, _data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.serviceLayers === null || this.serviceLayers.length === 0)) {
                _context2.next = 3;
                break;
              }

              //Return immediately with no results if layers hasn't been initialized or if no layers are indexed
              caller.fetchSuccess(this.createQueryResult());
              return _context2.abrupt("return");

            case 3:
              _context2.t0 = query.type;
              _context2.next = _context2.t0 === 'collapse' ? 6 : _context2.t0 === 'cut' ? 8 : _context2.t0 === 'no-cut' ? 8 : _context2.t0 === 'list' ? 8 : 29;
              break;

            case 6:
              caller.fetchSuccess(this.getLayersAsNewQueries());
              return _context2.abrupt("break", 29);

            case 8:
              layerIds = this.serviceLayerIds;
              if (query.hasTarget) layerIds = [this.getlayerIdFromType(query.target.type)];
              searchText = query.queryString;

              if (!query.isBlank) {
                _context2.next = 24;
                break;
              }

              if (!(layerIds.length === 1)) {
                _context2.next = 21;
                break;
              }

              layer = this.getLayerById(layerIds[0]);
              _context2.next = 16;
              return fetch2(this.serviceURL + '/' + layerIds[0] + '/query?f=json', {
                data: {
                  where: '1=1',
                  outFields: '*',
                  returnGeometry: true,
                  geometryPrecision: 3
                }
              });

            case 16:
              data = _context2.sent;
              data.query = query;
              caller.fetchSuccess(this.parseQueryResult(data, layer));
              _context2.next = 22;
              break;

            case 21:
              caller.fetchSuccess(this.getLayersAsNewQueries());

            case 22:
              _context2.next = 29;
              break;

            case 24:
              _context2.next = 26;
              return fetch2(this.serviceURL + '/find?f=json', {
                data: {
                  returnGeometry: true,
                  searchText: searchText,
                  layers: layerIds.join(),
                  returnFieldName: true
                }
              });

            case 26:
              _data = _context2.sent;
              _data.query = query;
              caller.fetchSuccess(this.parseFindResult(_data));

            case 29:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  getlayerIdFromType: function getlayerIdFromType(type) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = this.serviceLayers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var serviceLayer = _step3.value;
        if (type.toLowerCase() === serviceLayer.name.toLowerCase()) return serviceLayer.id;
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return "";
  },
  getLayersAsNewQueries: function getLayersAsNewQueries() {
    var queryResult = this.createQueryResult();
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = this.serviceLayers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var layer = _step4.value;
        queryResult.addNewQuery(this.source, layer.name, layer.name, null, "", null, null);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return queryResult;
  },
  error: function error(caller, jqXHR, textStatus, errorThrown) {
    caller.fetchError(this, errorThrown);
  },
  parseQueryResult: function parseQueryResult(data, layer) {
    var queryResult = this.createQueryResult();
    var query = data.query;
    var features = data.features;
    var displayFieldName = data.displayFieldName;
    var count = features.length;
    var hitsShown = count === 1 ? 1 : query.type === 'no-cut' && count > query.limit ? 0 : Math.min(count, query.limit);
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = features.slice(0, hitsShown)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var arcFeature = _step5.value;
        arcFeature.layerId = layer.id;
        var title = arcFeature.attributes[displayFieldName];
        var geometry = null;
        if (arcFeature.geometry) geometry = this.arcGisParser.parse(arcFeature.geometry);
        var result = queryResult.addResult(this.source, layer.name, title, null, geometry, arcFeature);
        result.id = arcFeature.attributes['OBJECTID'];
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    if (count > hitsShown && ["no-cut", "cut"].indexOf(query.type) !== -1) queryResult.addNewQuery(this.source, layer.name, layer.name + " (" + count + ")", null, "", null, null);
    return queryResult;
  },
  parseFindResult: function parseFindResult(data) {
    var queryResult = this.createQueryResult();
    var query = data.query;
    var returnedLayerIds = this.uniqueBy(data.results, function (result) {
      return result.layerId;
    });
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = returnedLayerIds[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var _ref2 = _step6.value;
        var key = _ref2.key;
        var results = _ref2.results;
        var layer = this.getLayerById(key);
        var type = layer.name;
        var count = results.length;
        var hitsShown = count === 1 ? 1 : query.type === 'no-cut' && count > query.limit ? 0 : Math.min(count, query.limit);
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = results.slice(0, hitsShown)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var arcResult = _step7.value;
            this.addResultFromArcResult(queryResult, arcResult, type);
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        if (count > hitsShown && ["no-cut", "cut"].indexOf(query.type) !== -1) queryResult.addNewQuery(this.source, type, type + " (" + count + ")", null, query.queryString, null, null);
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    return queryResult;
  },
  addResultFromArcResult: function addResultFromArcResult(queryResult, arcResult, type) {
    var displayAttribute = arcResult.displayFieldName;
    var title = arcResult.attributes[displayAttribute];
    var geometry = null;
    if (arcResult.geometry) geometry = this.arcGisParser.parse(arcResult.geometry);
    var result = queryResult.addResult(this.source, type, title, type, geometry, arcResult);
    result.isComplete = false;
    result.id = arcResult.attributes['OBJECTID'];
  },
  uniqueBy: function uniqueBy(arr, fn) {
    var count = {};
    var distinct = [];
    arr.forEach(function (x) {
      var key = fn(x);
      if (!count[key]) count[key] = [x];else count[key].push(x);
    });

    for (var prop in count) {
      distinct.push({
        key: prop,
        results: count[prop]
      });
    }

    return distinct;
  },
  getLayer: function getLayer(feature) {
    var layerId = feature.layerId;
    return this.getLayerById(layerId);
  },
  getLayerById: function getLayerById(layerId) {
    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = this.serviceLayers[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var serviceLayer = _step8.value;
        if ("" + layerId === "" + serviceLayer.id) return serviceLayer;
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }

    return null;
  },
  completeResult: function () {
    var _completeResult = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(result) {
      var feature, layerId, data;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!result.isComplete) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return", result);

            case 4:
              result.isComplete = true;
              feature = result.data;
              layerId = feature.layerId;
              _context3.next = 9;
              return fetch2(this.serviceURL + '/' + layerId + '/query?f=json', {
                data: {
                  where: 'OBJECTID=' + result.id,
                  outFields: '*',
                  returnGeometry: true,
                  geometryPrecision: 3
                }
              });

            case 9:
              data = _context3.sent;

              if (data.features && data.features.length > 0 && data.features[0].geometry) {
                feature = data.features[0];
                result.geometry = this.arcGisParser.parse(feature.geometry);
                feature.layerId = layerId;
                result.data = feature;
              }

              return _context3.abrupt("return", result);

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function completeResult(_x3) {
      return _completeResult.apply(this, arguments);
    }

    return completeResult;
  }(),
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(id, type) {
      var queryResult, layerId, layer, result, data, arcFeature, displayFieldName, title;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              queryResult = this.createQueryResult();
              layerId = this.getlayerIdFromType(type);
              layer = this.getLayerById(layerId);
              _context4.next = 5;
              return fetch2(this.serviceURL + '/' + layerId + '/query?f=json', {
                data: {
                  where: 'OBJECTID=' + id,
                  outFields: '*',
                  returnGeometry: true,
                  geometryPrecision: 3
                }
              });

            case 5:
              data = _context4.sent;

              if (data.features && data.features.length > 0 && data.features[0].geometry) {
                arcFeature = data.features[0];
                arcFeature.layerId = layerId;
                displayFieldName = data.displayFieldName;
                title = arcFeature.attributes[displayFieldName];
                result = queryResult.addResult(this.source, layer.name, title, layer.name, null, arcFeature);
                result.id = id;
                if (arcFeature.geometry) result.geometry = this.arcGisParser.parse(data.features[0].geometry);
              }

              return _context4.abrupt("return", result);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function get(_x4, _x5) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  CLASS_NAME: 'Septima.Search.arcGisSearcher'
});